"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixRatioContainer = void 0;
const pixi_js_1 = require("pixi.js");
class FixRatioContainer extends pixi_js_1.Container {
    constructor(initWidth, initHeight, autoRotate = false) {
        super();
        this.autoRotate = autoRotate;
        this._width = initWidth;
        this._height = initHeight;
    }
    get width() {
        return this._width * this.scale.x;
    }
    set width(v) {
        const p = v / this._width;
        this.scale.set(p, p);
    }
    get height() {
        return this._height * this.scale.x;
    }
    set height(v) {
        const p = v / this._height;
        this.scale.set(p, p);
    }
    setInit(width, height) {
        this._width = width;
        this._height = height;
    }
    get ratio() {
        return this._width / this._height;
    }
    resize(containerWidth, containerHeight, cover = false, hori = 0.5, vert = 0.5) {
        let cr = containerWidth / containerHeight;
        const r = this.ratio;
        if (this.autoRotate && (cr - 1) * (r - 1) < 0) {
            cr = containerHeight / containerWidth;
            if (cr > r !== cover) {
                this.height = containerWidth;
                this.x = containerWidth;
                this.y = containerHeight * hori - this.width * hori;
            }
            else {
                this.width = containerHeight;
                this.x = containerWidth * vert + this.height * vert;
                this.y = 0;
            }
        }
        else {
            if (cr > r !== cover) {
                this.height = containerHeight;
                this.x = containerWidth * hori - this.width * hori;
                this.y = 0;
            }
            else {
                this.width = containerWidth;
                this.x = 0;
                this.y = containerHeight * vert - this.height * vert;
            }
        }
    }
}
exports.FixRatioContainer = FixRatioContainer;
//# sourceMappingURL=FixRatioContainer.js.map